<template>
  <div class="chart-pie-project">
    <div class="chart-pie-project__graph">
      <EChartsCircular
        :seriesProp="seriesProp"
        :colors="color"
        variant="pie"
        labelMode="percent"
        :isShowLegend="false"
        :isShowBackground="false"
        :width="424"
      />
    </div>
    <div class="chart-pie-project__info">
      <div v-for="item in info" :key="item.id" class="chart-pie-project__item">
        <p class="chart-pie-project__item-count" :style="`color: ${item.color}`">
          <span class="chart-pie-project__item-dots" :style="`background-color: ${item.color}`"></span>
          {{ item.count }}
        </p>
        <p class="chart-pie-project__item-text">{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import EChartsCircular from '@/components/ChartComponents/apacheEcharts/EChartsCircular.vue';

  export default {
    name: 'ChartPieProject',
    components: {
      EChartsCircular,
    },
    props: {
      labelsArray: {
        type: Array,
        default: () => [],
      },
      countArray: {
        type: Array,
        default: () => [],
      },
      color: {
        type: Array,
        default: () => [],
      },
      info: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      seriesProp() {
        if (!Array.isArray(this.countArray) || this.countArray.length === 0) {
          return [];
        }

        return this.labelsArray.map((label, index) => ({
          name: label,
          count: Number(this.countArray[index]),
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart-pie-project {
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: 1px solid $grey;
    background: $light-grey;
    max-width: 848px;
    padding: 36px 0;
    overflow: hidden;

    &__graph {
      width: 100%;
      max-width: 424px;
    }

    &__info {
      margin-left: 64px;
    }

    &__item {
      margin-bottom: 32px;
      padding-left: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      &-count {
        font: $fira-32-M;
        position: relative;
      }

      &-text {
        font: $fira-16;
        color: $base;
      }

      &-dots {
        position: absolute;
        width: 12px;
        height: 12px;
        right: 100%;
        border-radius: 50%;
        top: 14px;
        margin-right: 12px;
      }
    }

    @media (max-width: $tablet) {
      &__info {
        margin-left: -4px;
      }
    }

    @media (max-width: $mobile) {
      flex-wrap: wrap;

      &__info {
        margin-left: 0;
        width: 100%;
        padding: 0 46px;
      }

      &__graph {
        margin: 0 0 50px;
      }

      &__item {
        margin-bottom: 20px;
      }
    }
  }
</style>
